export const pricingBreakdown = [
    { name: "Base Price", value: "base_price" },
    { name: "Fuel Surcharge", value: "fuel_surcharge" },
    { name: "Pickup Fee Price", value: "pickup_fee" },
    { name: "Service Charge", value: "service_charge" },
    { name: "Total Charge", value: "total_charge" },
]